import React, { Component } from 'react';
import PropTypes from 'prop-types';
import HeaderDropDown from 'components/Header/components/HeaderDropDown/';
import classNames from 'classnames';
import EarthIcon from './EarthIcon.js';
import { parseCompanyStyle } from 'utils';
import './style.css';

export default class LanguageMenuItem extends Component {
  handleClick(locale, event) {
    event.preventDefault();
    if (this.props.onSwitchLocale) {
      this.props.onSwitchLocale(locale);
    }
  }
  renderLocaleItem(locale, locales) {
    const localeItems = [];
    locales.forEach((localeObj, index) => {
      localeItems.push(
        <li
          key={localeObj.code}
          className={classNames({ active: locale === localeObj.code })}
          onClick={this.handleClick.bind(this, localeObj.code)}
        >
          <a className="language-selector__item ta__confirmation">{localeObj.name}</a>
        </li>
      );
      if (index !== locales.length - 1) {
        localeItems.push(<li className="divider" key={index}></li>);
      }
    });

    return localeItems;
  }
  render() {
    const { locales, locale, theme } = this.props;
    let localeText = locales[0].name;
    locales.forEach((localeObj) => {
      if (localeObj.code === locale) {
        localeText = localeObj.name;
      }
    });
    const companyStyle = parseCompanyStyle(theme.footerColor, theme.footerFontColor);

    return (
      <ul className="language-selector">
        <HeaderDropDown
          companyStyle={companyStyle}
          dropdownToggleClassName="language-selector__dropdown"
          title={
            <EarthIcon text={localeText} companyStyle={companyStyle} />
          }
          upCaret
        >
          { this.renderLocaleItem(locale, locales) }
        </HeaderDropDown>
      </ul>
    );
  }
}

LanguageMenuItem.propTypes = {
  locales: PropTypes.array.isRequired,
  onSwitchLocale: PropTypes.func.isRequired,
  locale: PropTypes.string.isRequired,
  theme: PropTypes.object,
};



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/420/s/Tube.Frontend/src/components/Footer/LanguageMenu/index.js
 **/